import {
  SET_DEV_TICKETS,
  SET_DEV_PAGE,
  SET_DEV_VERSION,
  SET_DEV_FILTER,
  SET_DEV_HASH,
  SET_VERSIONS,
  SET_LOADING,
  TicketsActionTypes,
  TicketsState,
} from './Types';

const initialState: TicketsState = {
  development: {
    currentPage: 0,
    currentFilter: 'All',
    currentVersion: '',
    requestHash: '',
    list: {
      page: 1,
      pageCount: 1,
      itemCount: 0,
      hasNextPage: false,
      hasPreviousPage: false,
      items: [],
    },
    versions: [],
  },
  loading: false,
};

export function ticketsReducer(state = initialState, action: TicketsActionTypes): TicketsState {
  switch (action.type) {
  case SET_DEV_TICKETS:
    return {
      ...state,
      development: {
        ...state.development,
        list: action.payload,
      },
    };
  case SET_DEV_PAGE:
    return {
      ...state,
      development: {
        ...state.development,
        currentPage: action.payload,
      },
    };
  case SET_DEV_VERSION:
    return {
      ...state,
      development: {
        ...state.development,
        currentVersion: action.payload,
        currentPage: 0,
      },
    };
  case SET_DEV_FILTER:
    return {
      ...state,
      development: {
        ...state.development,
        currentFilter: action.payload,
        currentPage: 0,
      },
    };
  case SET_DEV_HASH:
    return {
      ...state,
      development: {
        ...state.development,
        requestHash: action.payload,
      },
    };
  case SET_VERSIONS:
    return {
      ...state,
      development: {
        ...state.development,
        versions: action.payload,
      },
    };
  case SET_LOADING:
    return {
      ...state,
      loading: action.payload,
    };
  default:
    return state;
  }
}
